import React, { type FC } from 'react';
import MlsImagesViewer from './MlsImagesViewer';
import AvmMap from './maps/AvmMap';
import UserImagesViewer from './UserImagesViewer';
import { LoadingSpinner } from '../icons/OurIcons';
import { AvmCompForMap, PropertyDataProps } from '../../utility/types';
import NearbyListingMap from './maps/NearbyListingsMap';
import StreetViewer from './StreetViewer';

type ImagesMapDisplayProps = {
  property: PropertyDataProps;
  avmCompsForMap?: AvmCompForMap[];
  viewMlsImages: boolean;
  viewMap: boolean;
  viewNearbyListingsMap: boolean;
  viewUserImages: boolean;
  viewStreetView: boolean;
  mlsPropertyImages: any[];
  userImages: any[];
  isLoading: boolean;
  error: string;
};

const ImagesMapDisplay: FC<ImagesMapDisplayProps> = ({
  property,
  avmCompsForMap,
  viewMlsImages,
  viewMap,
  viewNearbyListingsMap,
  viewUserImages,
  viewStreetView,
  mlsPropertyImages,
  userImages,
  isLoading,
  error,
}) => {
  if (isLoading) {
    return (
      <div
        id="images-map-display-loading-container"
        className="flex items-center justify-center h-96"
      >
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div
        id="images-map-display-error-container"
        className="flex items-center justify-center h-96"
      >
        <div className="text-center">{error}</div>
      </div>
    );
  }

  if (
    !viewMlsImages &&
    !viewUserImages &&
    !viewMap &&
    !viewNearbyListingsMap &&
    !viewStreetView
  ) {
    return (
      <div
        id="images-map-display-no-images-container"
        className="flex items-center justify-center h-96"
      >
        <div className="text-center">No Images Data</div>
      </div>
    );
  }

  return (
    <div
      id="images-map-display-container"
      className="mt-2 min-w-max h-full p-3"
    >
      {viewMlsImages && (
        <div>
          <MlsImagesViewer propertyImages={mlsPropertyImages} />
        </div>
      )}
      {viewUserImages && (
        <div>
          <UserImagesViewer propertyImages={userImages} />
        </div>
      )}
      {viewMap && (
        <div className="h-96">
          <AvmMap property={property} comps={avmCompsForMap} />
        </div>
      )}
      {viewNearbyListingsMap && (
        <div className="h-96">
          <NearbyListingMap property={property} />
        </div>
      )}
      {viewStreetView && (
        <div className="h-96">
          <StreetViewer property={property} />
        </div>
      )}
    </div>
  );
};

export default ImagesMapDisplay;
